import * as React from 'react';
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import { Container } from '@mui/material';
import SideBarNav from '../../../../Layout/SideBarNav/SideBarNav';

import AddBuilderAgencyPage from './AddBuilderAgencyPage';
import UpdateBuilderAgencyPage from './UpdateBuilderAgencyPage';

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography component="div">{children}</Typography>
          {/* <Box>{children}</Box> */}
        </Box>
      )}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

export default function AddUpdateHQBuilderTabsPage() {
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <>

        <SideBarNav/>
        <Container>

            <Box sx={{ width: '100%' }}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
                <Tab label="Add Headquarter Builder Agency" {...a11yProps(0)} />
                <Tab label="Update Headquarter Builder Agency" {...a11yProps(1)} />
                {/* <Tab label="Item Three" {...a11yProps(2)} /> */}
                </Tabs>
            </Box>
            <CustomTabPanel value={value} index={0}>
                {/* Item One */}
                <AddBuilderAgencyPage/>
               
            </CustomTabPanel>
            <CustomTabPanel value={value} index={1}>
                {/* Item Two */}
                <UpdateBuilderAgencyPage/>
            </CustomTabPanel>
            {/* <CustomTabPanel value={value} index={2}>
                Item Three
            </CustomTabPanel> */}
            </Box>
        </Container>
    
    </>
  );
}